import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { initCounterAnimations } from './counter-animations';
import { initFadeInAnimations } from './fade-animations';
import { initScaleAnimations } from './scale-animations';
import { initRotateAnimations } from './rotate-animations';
import { initScrollAnimations } from './scroll-animations';


gsap.registerPlugin(ScrollTrigger);

export class ViewportAnimations {
    constructor() {
        this.init();
    }

    init() {
        initCounterAnimations();
        initFadeInAnimations();
        initScaleAnimations();
        initRotateAnimations();
        initScrollAnimations();
    }

    refresh() {
        ScrollTrigger.refresh();
    }

    destroy() {
        ScrollTrigger.killAll();
    }
}

export function initViewportAnimations() {
    return new ViewportAnimations();
}
